import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteFaqsSaga,
  getFaqsDetailsSaga,
  getFaqsListSaga,
} from "src/store/web-faqs/saga";
import { FaqsDetailDto, FaqsDto } from "src/store/web-faqs/type";
import FaqsCreateForm from "./create";
import FaqsEditForm from "./edit";
const FaqsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<FaqsDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<FaqsDetailDto>();
  const columns = [
    {
      text: t("Faqs.Question"),
      dataField: "Question",
    },
    {
      text: t("Faqs.ShowApp"),
      dataField: "ShowApp",
      formatter: (cellContent: boolean) =>
        cellContent ? (
          <i className="text-success bx  bx-check-square"></i>
        ) : (
          <i className="text-danger mdi mdi-close-box-outline"></i>
        ),
    },
    {
      text: t("Faqs.ShowWeb"),
      dataField: "ShowWeb",
      formatter: (cellContent: boolean) =>
        cellContent ? (
          <i className="text-success bx  bx-check-square"></i>
        ) : (
          <i className="text-danger mdi mdi-close-box-outline"></i>
        ),
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Faqs.PageTitle")}
        metaTag={t("Faqs.MetaTag")}
        gridProps={{
          addTitle: t("Faqs.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getFaqsListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getFaqsDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: FaqsDto) =>
              t("Faqs.DeleteQA", {
                name: data.Question,
              }),
            action: deleteFaqsSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <FaqsCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getFaqsListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <FaqsEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getFaqsListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default FaqsPage;
